import React, { createContext, useContext, useEffect, useState } from 'react'
import { CoinList } from './config/api';
import axios from "axios";
import { onAuthStateChanged } from 'firebase/auth';
import { auth, db } from './firebase';
import { doc, onSnapshot } from 'firebase/firestore';


const Crypto = createContext()

function CryptoContext({children}) {
    const [currency,setCurrency] = useState("INR")
    const [symbol,setSymbol] = useState("₹")
    const [coins, setCoins] = useState([]);
    const [loading, setLoading] = useState(false);

    const [user,setUser] = useState(null)
    const [watchlist,setWatchList] = useState([])

    useEffect(()=>{
      if(user){
        const coinRef = doc(db,"watchlist",user.uid);

        //onSnapshot() checks if a databse is updated or not
        var unsubscribe = onSnapshot(coinRef,coin=>{
          if(coin.exists()){
            setWatchList(coin.data().coins);
          }else{
            console.log("No Items in Watchlist")
          }
        })
        return () => { unsubscribe()}
      }

    },[user])


    const [alert,setAlert] = useState({
      open:false,
      message:"",
      type:"success"
    })
    useEffect(()=>{
      onAuthStateChanged(auth,(user)=>{
        if(user)setUser(user);
        else setUser(null);
      })
    },[])
    
    const fetchCoins = async () => {
      setLoading(true);
      const { data } = await axios.get(CoinList(currency));
      setCoins(data);
      setLoading(false);
    };

    useEffect(()=>{
        if(currency === "INR") setSymbol("₹");
        else if(currency === "USD") setSymbol("$");
        else if(currency === "EUR") setSymbol("€");
    },[currency])

  return (
    <Crypto.Provider value={{currency,symbol,setCurrency,coins,loading,fetchCoins,alert,setAlert,user,watchlist}}>
        {children}
    </Crypto.Provider>
  )
}

export default CryptoContext


export const CryptoState = ()=>{
    return useContext(Crypto)
}